import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../Constant";
import BarLoader from "react-bar-loader";

import ImagesUploader from "react-images-uploader";

export default class Topics extends Component {
  state = {
    enableCourseName: false,
    enableCourseDisc: false,
    loading: true,
    data: [],
    trainerOptions: [
      {
        id: 1,
        name: "CONTENT",
        subname: "0 inactive",
        icons: <i class="fas fa-th"></i>,
      },
      {
        id: 2,
        name: "USERS & PROGRESS",
        subname: "1 instructor · 0 learners",
        icons: <i class="fas fa-user"></i>,
      },
      {
        id: 3,
        name: "FILES",
        subname: "0 files",
        icons: <i class="fas fa-folder-open"></i>,
      },
      {
        id: 4,
        name: "RULES & PATH ",
        subname: "Sequential rule set",
        icons: <i class="fas fa-chart-line"></i>,
      },
      {
        id: 5,
        name: "REPORTS",
        subname: "No Reports",
        icons: <i class="fas fa-chart-pie"></i>,
      },
    ],
    columns: [
      {
        name: 'Image',
        selector: 'image',
        sortable: true,
        width: '100px',
        cell: row => (
          <img src={row.image !== ""
            ? row.image
            : "./images/homepage/placeholder-img.jpg"
          } alt="" className="image_square py-2" onError={e => {
            e.target.src = "./images/homepage/placeholder-img.jpg"
          }} />
        )
      }, {
        name: "Topic Name",
        selector: "name",
        sortable: true,
      },
      {
        name: "Topic Type",
        selector: "contentType",
        sortable: true,
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        cell: (row) => (
          <div className="d-flex">
            <Link
              to={`/admin/edit-topic/${this.props.match.params.course_id}&${row.id}`}
            >
              <i
                class=" btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-primary"
                id={row.id}
              ></i>
            </Link>
            <i
              class="btn btn-light shadow-sm mx-1 fas fa-times text-danger"
              id={row.id}
              onClick={this.deleteTopic}
            ></i>

            <Link
              to={`/admin/view-topic/${this.props.match.params.course_id}&${row.id}`}
            >
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-share text-dark"
                id={row.id}
              ></i>
            </Link>
          </div>
        ),
      },
    ],
  };
  componentDidMount() {
    this.setState({ courseId: this.props.match.params.course_id });
    this.getTopics();
    this.getCourse();
  }
  getCourse() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        this.setState({
          courseName: data.name,
          courseDisc: data.description,
          courseImage: data.image,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  }
  getTopics = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        const desc = result.description;
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
        }
        this.setState({ topics: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };

  deleteTopic = (e) => {
    var topicId = e.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("topicId", topicId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/delete", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        document.location.reload();
      })
      .catch((error) => console.log("error", error));
  };

  updateCourse = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);
    urlencoded.append("name", this.state.courseName);
    urlencoded.append("description", this.state.courseDisc);
    urlencoded.append("image", this.state.courseImage);
    urlencoded.append("content", []);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/update", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        document.location.reload();
      })
      .catch((error) => console.log("error", error));
  };

  enableCourseName = () => {
    this.setState({ enableCourseName: true });
  };
  enableCourseDisc = () => {
    this.setState({ enableCourseDisc: true });
  };
  closeNameEditing = () => {
    this.setState({ enableCourseName: false });
  };
  closeDiscEditing = () => {
    this.setState({ enableCourseDisc: false });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSelectedOptions = () => { };

  onChangeImage = (e) => {
    if (window.FileReader) {
      var file = e.target.files[0];
      var reader = new FileReader();
      if (file && file.type.match("image.*")) {
        reader.readAsDataURL(file);
      } else {
        // img.css('display', 'none');
        // img.attr('src', '');
      }
      reader.onloadend = (e) => {
        this.setState({
          courseImage: reader.result,
        });

        var courseImage = Constant.uploadImage(reader.result);
        this.setState({ courseImage: courseImage });
      };
    }
  };
  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-6 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/admin/dashboard">Home</Link> /{" "}
                    <Link to="/admin/courses">Courses</Link> /{" "}
                    {this.state.courseName}
                  </h5>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <Link
                    to={`/admin/add-topic/${this.props.match.params.course_id}`}
                    className="btn btn-dark float-right"
                  >
                    Add Topic
                  </Link>
                </div>
              </div>
            </div>

            <div className="users-container p-2">
              {this.state.loading == true ? (
                <div className="container p-5">
                  <div className="col-md-3 mx-auto">
                    <BarLoader color="#33cabb" height="4" />
                  </div>
                </div>
              ) : (
                  <DataTable
                    noHeader={true}
                    columns={this.state.columns}
                    data={this.state.topics}
                    theme="solarized"
                    pagination={true}
                    noDataComponent={
                      <div className="m-3">No Topics Available</div>
                    }
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
